import ApiConfig from "../Config";
import apiService from "../services/apiService";

const collectionService = {
  getProductsByCollection: (id) =>
    apiService.get(ApiConfig.getProductListByCollection, {
      headers: { "collection-id": id },
    }),

  getCollections: () => apiService.get(ApiConfig.getCollections),

  addProductsToCollection: (collectionId, productIds) =>
    apiService.post(ApiConfig.addProductsToCollection, {
      collectionId,
      productIds,
    }),

  removeProductsFromCollection: (collectionId, productIds) =>
    apiService.post(ApiConfig.removeProductsFromCollection, {
      collectionId,
      productIds,
    }),

  setActiveCollection: (collectionId, currentStatus) =>
    apiService.post(
      ApiConfig.setActiveCollection,
      {},
      {
        headers: {
          "collection-id": collectionId,
          "is-active": !currentStatus,
        },
      },
    ),

  createCollection: (collectionData) =>
    apiService.post(ApiConfig.createCollection, collectionData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }),

  editCollection: (collectionData) =>
    apiService.post(ApiConfig.editCollection, collectionData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }),

  deleteCollection: (collectionId) =>
    apiService.post(ApiConfig.deleteCollection, { collectionId }),
};
export default collectionService;
